import { render, staticRenderFns } from "./BaseCardCreateUpdate.vue?vue&type=template&id=2f16dbca&scoped=true&"
import script from "./BaseCardCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./BaseCardCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardCreateUpdate.vue?vue&type=style&index=0&id=2f16dbca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16dbca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f16dbca')) {
      api.createRecord('2f16dbca', component.options)
    } else {
      api.reload('2f16dbca', component.options)
    }
    module.hot.accept("./BaseCardCreateUpdate.vue?vue&type=template&id=2f16dbca&scoped=true&", function () {
      api.rerender('2f16dbca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Cards/BaseCardCreateUpdate.vue"
export default component.exports